import toast from "react-hot-toast";
import { TiTick, TiTimes } from "react-icons/ti";
import { useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//
import {
  useHandleRejectRequestMutation,
  useHandleAcceptRequestMutation,
    useHandleRejectCashRequestMutation,
  useFetchAllTheCashTransferRequestsMutation,
} from "../../../features/tenant/cashTransactions/cashTransactionsApi";
import {
  useGetApprovalLogsByRefMutation,
  useGetBatchApprovalStatusMutation,
} from "../../../features/tenant/approvalLog/approvalLog.Api";
import { getVendorName } from "../../../utils/getVendorName";
import { hasPermission } from "../../../utils/hasPermission";
import CustomExport from "../../../components/CustomExport/CustomExport";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import TenantSlugs from "../../../utils/TenantSlug";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useFetchAllSchemeMutation } from "../../../features/tenant/scheme/schemeApi";
import { useApproveTalbrosBulkRedemptionsMutation } from "../../../features/tenant/talbros/talbrosApi";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";

// ── Default Sample Template Data ─────────────────────────────────────────────
const templateDataDefault = [
    {
        name: "ref_no",
        label: "Sample Ref No",
        maxLength: 100,
    },
    {
        name: "approve",
        label: "true/false",
        maxLength: 100,
    },
    {
        name: "utr",
        label: "Sample UTR",
        maxLength: 100,
    },
];

// ── Sample Template Data for Credit Note (cn) ────────────────────
const templateDataCN = [
    {
        name: "ref_no",
        label: "Sample Ref No",
        maxLength: 100,
    },
    {
        name: "approve",
        label: "true/false",
        maxLength: 100,
    },
    {
        name: "cn_no",
        label: "Sample CN number",
        maxLength: 100,
    },
];

const idToZoneMapping = {
  202: "East",
  200: "South",
  199: "North",
  201: "West",
};

const CashTransferRequests = ({onlyScheme = false}) => {
  const navigate = useNavigate();
  const location = useLocation();

    const CN_ENABLED_TENANTS = [
    TenantSlugs['talbros'],
    TenantSlugs['modenik'],
  ];

   const tenant_id= JSON.parse(sessionStorage.getItem("vendorData")).tenant_id;

   const is_cn = CN_ENABLED_TENANTS.some((slug) => slug == tenant_id);
   const is_talbros = tenant_id == TenantSlugs['talbros'];
   const is_sudama = tenant_id == TenantSlugs['sudama'];
   const is_lotus = tenant_id == TenantSlugs['lotus'] || window.location.href.includes("lotus");
  

  const [tableDataItems, setTableDataItems] = useState([]);

  const [myList, setMyList] = useState([])
  const [totalRows, setTotalRows] = useState(0);

  const [bulkRedemptionsFile, setBulkRedemptionsFile] = useState(null);
  const [csvModal, setCsvModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  // ── Sudama approve modal ──────────────────────────────────────────────────
  const [sudamaModal, setSudamaModal]           = useState(false);
  const [sudamaRow, setSudamaRow]               = useState(null);
  const [sudamaIsApproved, setSudamaIsApproved] = useState(true);
  const [sudamaUtr, setSudamaUtr]               = useState("");
  const [sudamaRemark, setSudamaRemark]         = useState("");
  // ─────────────────────────────────────────────────────────────────────────
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState(appUserTypes);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const initialRequest = {
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate:"",
    request_type: "",
  type: onlyScheme ? "scheme" : "",
  ...onlyScheme ? {
    scheme_id: ""
  } : {}
  };
  const [request, setRequest] = useState(initialRequest);

    // ── Dynamically compute CSV template based on selected request_type ──
    const currentTemplateData = useMemo(() => {
      return request.request_type === "cn" ? templateDataCN : templateDataDefault;
    }, [request.request_type]);

  // Updated Credit Note row check: handles pending requests where cn_no is not yet present
  const isCreditNoteRow = (row) =>
    row?.transaction_type === "cn" ||
    row?.type === "cn" ||
    row?.request_type === "cn" ||
    !!row?.cn_no;

    
  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element.user_type.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  const clearFilters = () => {
    setRequest(initialRequest);
  };

  const [
    fetchAllTheCashTransferRequests,
    {
      data: fetchAllTheCashTransferRequestsData,
      error: fetchAllTheCashTransferRequestsError,
      isLoading : fetchAllTheCashTransferRequestsisLoading,
    },
  ] = useFetchAllTheCashTransferRequestsMutation();

  const [
    fetchAllTheCashTransferRequestsCSV,
    {
      data: fetchAllTheCashTransferRequestsCSVData,
      error: fetchAllTheCashTransferRequestsCSVError,
    },
  ] = useFetchAllTheCashTransferRequestsMutation();

  const [
    handleAcceptRequest,
    { data: handleAcceptRequestData, error: handleAcceptRequestError },
  ] = useHandleAcceptRequestMutation();

  const [
    handleRejectRequest,
    { data: handleRejectRequestData, error: handleRejectRequestError },
  ] = useHandleRejectRequestMutation();

  const [
    handleRejectCashRequest,
    { data: handleRejectCashRequestData, error: handleRejectCashRequestError },
  ] = useHandleRejectCashRequestMutation();

  const [
      approveTalbrosBulkRedemptions,
      {
          data: approveTalbrosBulkRedemptionsData,
          error: approveTalbrosBulkRedemptionsError,
      },
  ] = useApproveTalbrosBulkRedemptionsMutation();

  // ── Approval history ──────────────────────────────────────────────────────
  const [historyModal, setHistoryModal] = useState(false);
  const [historyRow, setHistoryRow]     = useState(null);
  const [historyLogs, setHistoryLogs]   = useState([]);

  const [
    getApprovalLogsByRef,
    { data: approvalLogsData, isLoading: approvalLogsLoading },
  ] = useGetApprovalLogsByRefMutation();

  const openHistory = (row) => {
    setHistoryRow(row);
    setHistoryLogs([]);
    setHistoryModal(true);
    getApprovalLogsByRef({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      ref_table_name: "cash_tranfer_to_bank",
      ref_table_id: row.id,
    });
  };

  useEffect(() => {
    if (approvalLogsData?.body) {
      setHistoryLogs(approvalLogsData.body);
    }
  }, [approvalLogsData]);

  // ── Batch workflow status ──────────────────────────────────────────────────
  const [rowWorkflowStatus, setRowWorkflowStatus] = useState({});
  const [getBatchApprovalStatus] = useGetBatchApprovalStatusMutation();

  const fetchBatchWorkflowStatus = async (rows) => {
    if (!rows || rows.length === 0) return;
    try {
      const res = await getBatchApprovalStatus({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        ref_table_name: "cash_tranfer_to_bank",
        ref_ids: rows.map((r) => r.id),
      }).unwrap();
      if (res?.body) setRowWorkflowStatus(res.body);
    } catch (e) {
      console.error("batch workflow status error", e);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  const hasViewPermission = hasPermission("viewTransactionRequestList");
  const hasAcceptPermission = hasPermission("acceptTransactionRequestList");
  const hasRejectPermission = hasPermission("rejectTransactionRequestList");

  // Pass transaction_type dynamically in body to match backend filter
  // const handleCashTransferList = (overrideLimit, overrideOffset) => {
  //   const payload = {
  //     ...request,
  //     limit: overrideLimit !== undefined ? overrideLimit : request.limit,
  //     offset: overrideOffset !== undefined ? overrideOffset : request.offset,
  //     transaction_type: request.request_type,
  //   };
  //   delete payload.request_type;

  //   fetchAllTheCashTransferRequests({
  //     tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
  //     token: sessionStorage.getItem("access_token"),
  //     body: payload
  //   });
  // };

  const handleCashTransferList = (overrideLimit, overrideOffset) => {
    const payload = {
      ...request,
      limit: overrideLimit !== undefined ? overrideLimit : request.limit,
      offset: overrideOffset !== undefined ? overrideOffset : request.offset,
      // Map request_type selection directly to the database column 'type'
      type: request.request_type || (onlyScheme ? "scheme" : ""),
    };
    
    delete payload.request_type;

    fetchAllTheCashTransferRequests({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: payload
    });
  };

  // Pass transaction_type dynamically for CSV fetch
  // const handleCashTransferListCSV = () => {
  //   const modifiedRequest = {
  //     ...request,
  //     transaction_type: request.request_type,
  //     limit: null,
  //     offset: null,
  //   };
  //   delete modifiedRequest.request_type;

  //   fetchAllTheCashTransferRequestsCSV({
  //     tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
  //     token: sessionStorage.getItem("access_token"),
  //     body: modifiedRequest
  //   });
  // };

  const handleCashTransferListCSV = () => {
    const modifiedRequest = {
      ...request,
      type: request.request_type || (onlyScheme ? "scheme" : ""),
      limit: null,
      offset: null,
    };
    
    delete modifiedRequest.request_type;

    fetchAllTheCashTransferRequestsCSV({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: modifiedRequest
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (fetchAllTheCashTransferRequestsCSVData && fetchAllTheCashTransferRequestsCSVData?.body?.data) {
      let temp_data = fetchAllTheCashTransferRequestsCSVData?.body?.data;

      temp_data = temp_data?.map((item) => {
        let bene_details_parsed = {};
        try {
          if (item.bene_details) {
            bene_details_parsed = typeof item.bene_details === "string" ? JSON.parse(item.bene_details) : item.bene_details;
          }
        } catch (e) {
          console.error("Error parsing bene_details", e);
        }

        const updatedItem = {};
        Object.keys(item).forEach((key) => {
          if (key === "bene_details") {
            updatedItem.bene_account_number = bene_details_parsed.bankAccount || bene_details_parsed.vpa || "";
            updatedItem.bene_ifsc = bene_details_parsed.ifsc || "";
          } else {
            updatedItem[key] = item[key];
          }
        });

        Object.keys(bene_details_parsed).forEach((bKey) => {
          if (!["bankAccount", "ifsc", "vpa", "account_id"].includes(bKey)) {
            const newKey = updatedItem.hasOwnProperty(bKey) ? `bene_${bKey}` : bKey;
            updatedItem[newKey] = bene_details_parsed[bKey];
          }
        });

        if (is_cn) {
          updatedItem.utr = item.remarks || "";
        }

        if (is_lotus) {
          updatedItem.zone = idToZoneMapping[Number(item.added_by_id)] || item.zone_name || "";
          updatedItem.zone_name = idToZoneMapping[Number(item.added_by_id)] || item.zone_name || "";
          updatedItem.salon_zone = idToZoneMapping[Number(item.added_by_id)] || item.salon_zone || item.zone_name || "";
        }

        return updatedItem;
      });

      setCsvData(temp_data);
    }

    if (fetchAllTheCashTransferRequestsCSVError) {
      setCsvData(null);
    }
  }, [fetchAllTheCashTransferRequestsCSVData, fetchAllTheCashTransferRequestsCSVError, is_cn]);


  useEffect(() => {
    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }
    handleCashTransferList(limit, offset);
  
  }, [limit, offset]);

  const isFirstRequestTypeRun = useRef(true);

  useEffect(() => {
    if (isFirstRequestTypeRun.current) {
      isFirstRequestTypeRun.current = false;
      return;
    }
    handleCashTransferList();
  }, [request.request_type]);

  useEffect(() => {
    if (
      fetchAllTheCashTransferRequestsData &&
      fetchAllTheCashTransferRequestsData.body
    ) {
      console.log(
        "transactionsData  data",
        fetchAllTheCashTransferRequestsData
      );
      const arr = [...fetchAllTheCashTransferRequestsData.body.data];
      setTableDataItems(arr);
      fetchBatchWorkflowStatus(arr);

      setTotalRows( fetchAllTheCashTransferRequestsData &&
        fetchAllTheCashTransferRequestsData.body.count ? fetchAllTheCashTransferRequestsData.body.count  : 0 );

      
    }

    if (fetchAllTheCashTransferRequestsError) {
      console.log(
        "transactionsData error",
        fetchAllTheCashTransferRequestsError
      );
      toast.dismiss();
      toast.error(`${fetchAllTheCashTransferRequestsError.data.message}`, {
        id: "fetchAllTheCashTransferRequestsError",
      });
    }
  }, [
    fetchAllTheCashTransferRequestsData,
    fetchAllTheCashTransferRequestsError,
  ]);

  const handleApprove = (e, row) => {
      if (e?.preventDefault) {
          e?.preventDefault();
      }
      const remark = window.prompt("please add remarks");

      if (!remark || remark?.length < 1) {
          toast.error("Please add a remark");
          return;
      }

      if (remark && remark.length > 0) {
          console.log("remark", remark);
          handleAcceptRequest({
              token: sessionStorage.getItem("access_token"),
              tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                  .tenant_id,
              body: {
                  remark: remark,
              },
              account_id: row.account_id.toString(),
              cash_transfer_to_bank_id: row.id.toString(),
          });
          return;
      }
  };

  const handleTalbrosApprove = (e, row, is_approved = true) => {
      if (e?.preventDefault) e?.preventDefault();

      const ws = rowWorkflowStatus[row.id];
      const isFinalLevel = !ws || ws.no_workflow || (ws.current_level === ws.total_levels);

      if (is_sudama) {
          setSudamaRow(row);
          setSudamaIsApproved(is_approved);
          setSudamaUtr("");
          setSudamaRemark("");
          setSudamaModal(true);
          return;
      }

      const ref_no = row?.redemption_refno || row?.ref_no;

      if (!is_approved) {
          const remark = window.prompt("Please add remarks for rejection");
          if (remark === null) return;
          if (remark?.trim()?.length < 1) {
              toast.error("Please add a remark!");
              return;
          }
          approveTalbrosBulkRedemptions({
              token: sessionStorage.getItem("access_token"),
              tenant_id: tenant_id,
              body: {
                  list: [
                      {
                          ref_no: ref_no,
                          approve: false,
                          utr: "",
                          remark: remark.trim(),
                      },
                  ],
              },
          });
          return;
      }

      if (isFinalLevel) {
          const remark = window.prompt("Please add remarks");
          if (remark === null) return;
          if (remark?.trim()?.length < 1) {
              toast.error("Please add a remark!");
              return;
          }

          const isCN = isCreditNoteRow(row);

          const refValue = window.prompt(
              isCN ? "Please add CN Number (mandatory)" : "Please add UTR (mandatory)"
          );
          if (refValue === null) return;
          if (refValue?.trim()?.length < 1) {
              toast.error(isCN ? "Please add CN Number !" : "Please add UTR !");
              return;
          }

          approveTalbrosBulkRedemptions({
              token: sessionStorage.getItem("access_token"),
              tenant_id: tenant_id,
              body: {
                  list: [
                      {
                          ref_no: ref_no,
                          approve: true,
                          ...(isCN
                              ? { cn_no: refValue.trim() }
                              : { utr: refValue.trim() }),
                          remark: remark.trim(),
                      },
                  ],
              },
          });
      } else {
          const remark = window.prompt("Please add remarks");
          if (remark === null) return;
          if (remark?.trim()?.length < 1) {
              toast.error("Please add a remark!");
              return;
          }

          approveTalbrosBulkRedemptions({
              token: sessionStorage.getItem("access_token"),
              tenant_id: tenant_id,
              body: {
                  list: [
                      {
                          ref_no: ref_no,
                          approve: true,
                          utr: "",
                          remark: remark.trim(),
                      },
                  ],
              },
          });
      }
  };

  const handleSudamaConfirm = () => {
      if (!sudamaRemark?.trim()) {
          toast.error("Remark is required");
          return;
      }

      const ws = rowWorkflowStatus[sudamaRow?.id];
      const isFinalLevel = !ws || ws.no_workflow || (ws.current_level === ws.total_levels);

      if (sudamaIsApproved && isFinalLevel && !sudamaUtr?.trim()) {
          toast.error("UTR is required");
          return;
      }

      const ref_no = sudamaRow?.redemption_refno || sudamaRow?.ref_no;
      const payload = {
          list: [
              {
                  ref_no,
                  approve: sudamaIsApproved,
                  utr: (sudamaIsApproved && isFinalLevel) ? sudamaUtr?.trim() : "",
                  remark: sudamaRemark?.trim(),
              },
          ],
      };
      approveTalbrosBulkRedemptions({
          token: sessionStorage.getItem("access_token"),
          tenant_id: tenant_id,
          body: payload,
      });
      setSudamaModal(false);
  };

  useEffect(() => {
    if (handleAcceptRequestData) {
      toast.dismiss();
      toast.success(`${handleAcceptRequestData.message}`, {
        id: "handleAcceptRequestData",
      });
      handleCashTransferList(limit, offset);
    }

    if (handleAcceptRequestError) {
      toast.dismiss();
      toast.error(`${handleAcceptRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
      handleCashTransferList(limit, offset);
    }
  }, [handleAcceptRequestData, handleAcceptRequestError]);

  useEffect(() => {
      if (approveTalbrosBulkRedemptionsData) {
          toast.dismiss();
          if(is_sudama)
          {
            toast.success(
                `${approveTalbrosBulkRedemptionsData.message}`,
                {
                    id: "approveTalbrosBulkRedemptionsData",
                },
            );
          }else{
            toast.success(
                `Approved: ${approveTalbrosBulkRedemptionsData?.body?.success?.length} - Failed: ${approveTalbrosBulkRedemptionsData?.body?.failed?.length}`,
                {
                    id: "approveTalbrosBulkRedemptionsData",
                },
            );
          }
          handleCashTransferList(limit, offset);
      }

      if (approveTalbrosBulkRedemptionsError) {
          toast.dismiss();
          toast.error(`${approveTalbrosBulkRedemptionsError.data.message}`, {
              id: "approveTalbrosBulkRedemptionsError",
          });
      }
  }, [approveTalbrosBulkRedemptionsData, approveTalbrosBulkRedemptionsError]);

  const handleReject = (e, row) => {
    const remark = window.prompt("please add remarks");
    if (!remark || remark?.length < 1) {
      toast.error("Please add a remark");
      return;
    }

    handleRejectRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        remark: remark,
      },
      account_id: row.account_id.toString(),
      cash_transfer_to_bank_id: row.id.toString(),
    });
  };

  useEffect(() => {
    if (handleRejectRequestData) {
      toast.dismiss();
      toast.success(`${handleRejectRequestData.message}`, {
        id: "handleRejectRequestData",
      });
      handleCashTransferList(limit, offset);
    }

    if (handleRejectRequestError) {
      toast.dismiss();
      toast.error(`${handleRejectRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleRejectRequestData, handleRejectRequestError]);


  const handleRejectCash = (e, row) => {
    const remark = window.prompt("please add remarks");
    if (remark && remark.length == 0) {
      toast.error("Please add a remark");
      return;
    }

    handleRejectCashRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        remark: remark,
      },
      account_id: row.account_id.toString(),
      cash_transfer_to_bank_id: row.id.toString(),
    });
  };

  useEffect(() => {
    if (handleRejectCashRequestData) {
      toast.dismiss();
      toast.success(`${handleRejectCashRequestData.message}`, {
        id: "handleRejectRequestData",
      });
      handleCashTransferList(limit, offset);
    }

    if (handleRejectCashRequestError) {
      toast.dismiss();
      toast.error(`${handleRejectCashRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleRejectCashRequestData, handleRejectCashRequestError]);

  const columns = [
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "160px"
    },
    {
      name: "Mobile  ",
      selector: (row) => row.mobile,
      width: "160px"
    },
    ...TenantSlugs.sudama == JSON.parse(sessionStorage.getItem("vendorData")).tenant_id? [
      {
        name: "Updated Name",
        selector: (row) => row.updated_by_name,
      },
      {
        name: "Updated Mobile",
        selector: (row) => row.updated_by_mobile,
      },
      {
        name: "Updated Email",
        selector: (row) => row.updated_by_email,
      },
      {
        name: "Order Points",
        selector: (row) => row.cash - (row.gift_balance || 0),
      },
      {
        name: "Bonus Points",
        selector: (row) => row.gift_balance || 0,
      }
    ] : [],
    {
      name: "User Type",
      selector: (row) => row.user_type,
    },
    {
            name: "Redemption Type",
            selector: (row) =>
                onlyScheme ? (
                    <div className="flex flex-col items-center justify-center">
                      <span className="text-gray-600 !m-0 !p-0">
                        Scheme:
                      </span>
                      <b>
                      {
                          schemeData?.body?.data?.find(
                              (item) => item?.id == row?.scheme_id
                          )?.name
                      }
                      </b>
                    </div>
                ) : (
                    "Product"
                ),
            width: onlyScheme ? "200px" : "100px",
    },
    {
      name: "Last Balance",
      selector: (row) => row.balance,
      width: "160px"
    },
    {
      name: "Redemption Amount",
      selector: (row) => row.cash,
      width: "180px"
    },
    {
      name: "MRP",
      selector: (row) => row.mrp || "--",
      width: "120px",
    },
    {
      name: "Scratch Code",
      selector: (row) => row.scratch_code || "--",
      width: "150px",
    },
    {
      name: onlyScheme ? "Available balance" : "Total Redemption Amount",
      selector: (row) => onlyScheme ? (Number(row.balance) - Number(row.cash)).toFixed(2) : row.amount_without_tds,
      width: "160px"
    },
    {
      name: "Transfer ID  ",
      selector: (row) => <span title={row?.transfer_id}>{row.transfer_id}</span>,
      width: "280px"
    },
    {
      name: "State ",
      selector: (row) => <span title={row?.state}>{row.state || "--"}</span>,
    },
    {
      name: "District ",
      selector: (row) => <span title={row?.district}>{row.district || "--"}</span>,
    },
    {
      name: "City",
      selector: (row) => <span title={row?.city}>{row.city || "--"}</span>,
    },
    ...!onlyScheme ? [
      {
        name: "Compound Address",
        selector: (row) => row.compound_address || "--",
      }
    ] : [],
    ...is_lotus ? [
      {
        name: "Salon ID",
        selector: (row) => row.salon_id || "--",
        width: "150px"
      },
      {
        name: "Salon Name",
        selector: (row) => row.salon_name || "--",
        width: "200px"
      },
      {
        name: "Salon Zone",
        selector: (row) => idToZoneMapping[Number(row.added_by_id)] || row.salon_zone || row.zone_name || "--",
        width: "150px"
      },
      {
        name: "Salon Address",
        selector: (row) => row.salon_address || "--",
        width: "250px"
      }
    ] : [],
    {
      name: "Remarks",
      selector: (row) => row.remarks || "--",
      ...is_cn ? {
        width: "180px"
      } : {}
    },
    ...is_cn ? [{
      name: "CN No. / UTR",
      selector: (row) =>
        isCreditNoteRow(row) ? (row.cn_no || "--") : (row.utr || "--"),
      width: "160px",
    }] : [],
    {
      name: "Request Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action Taken At",
      selector: (row) => row.action_date == null ? "--" : new Date(row.action_date).toLocaleString(),
      sortable: true,
      width: "170px",
    },
    {
      name: "",
      cell: (r) => (
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => {
            setModalData(r);
            setShowModal(true);
          }}
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "",
      cell: (r) => {
        const ws = rowWorkflowStatus[r.id];
        if (!ws || ws.no_workflow) return null;
        return (
          <button
            title="Approval History"
            style={{
              display: "inline-flex", alignItems: "center", gap: "3px",
              fontSize: "11px", fontWeight: 600, padding: "3px 8px",
              borderRadius: "12px", border: "1px solid #6366f1",
              color: "#6366f1", background: "#eef2ff", cursor: "pointer",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#e0e7ff"}
            onMouseLeave={e => e.currentTarget.style.background = "#eef2ff"}
            onClick={() => openHistory(r)}
          >
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
            History
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: false,
      width: "100px",
    },

    {
      name: "Actions",
      cell: (row) => {
        const ws = rowWorkflowStatus[row.id];

        if (ws && !ws.no_workflow) {
          if (ws.is_fully_approved) {
            return <div className="bg-green-600 text-white px-2 py-1 rounded-full font-bold text-xs">Approved</div>;
          }
          if (ws.is_rejected) {
            return <div className="bg-red-600 text-white px-2 py-1 rounded-full font-bold text-xs">Rejected</div>;
          }

          const levelPill = (
            <span style={{ fontSize: "9px", fontWeight: 700, padding: "1px 6px", borderRadius: "10px", background: "#f1f5f9", color: "#64748b", letterSpacing: "0.03em" }}>
              Level {ws.current_level}/{ws.total_levels}
            </span>
          );

          if (ws.can_approve && row.approval_status == "3") {
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                {levelPill}
                <div style={{ display: "flex", gap: "4px" }}>
                  {hasAcceptPermission && (
                    <button
                      onClick={(e) => is_cn || is_sudama ? handleTalbrosApprove(e, row, true) : handleApprove(e, row)}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "3px",
                        fontSize: "11px", fontWeight: 600, padding: "4px 8px",
                        borderRadius: "6px", border: "none",
                        background: "linear-gradient(135deg,#16a34a,#15803d)",
                        color: "#fff", cursor: "pointer",
                        boxShadow: "0 1px 3px rgba(22,163,74,0.35)",
                      }}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      Accept
                    </button>
                  )}
                  {hasRejectPermission && (
                    <button
                      onClick={(e) => is_cn ? handleTalbrosApprove(e, row, false) : (tenant_id == 26 ? handleRejectCash(e, row) : handleReject(e, row))}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "3px",
                        fontSize: "11px", fontWeight: 600, padding: "4px 8px",
                        borderRadius: "6px", border: "none",
                        background: "linear-gradient(135deg,#dc2626,#b91c1c)",
                        color: "#fff", cursor: "pointer",
                        boxShadow: "0 1px 3px rgba(220,38,38,0.35)",
                      }}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      Reject
                    </button>
                  )}
                </div>
              </div>
            );
          }

          return (
            <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
              {levelPill}
              <span style={{
                display: "inline-flex", alignItems: "center", gap: "4px",
                fontSize: "11px", fontWeight: 600, padding: "4px 10px",
                borderRadius: "6px", background: "#fffbeb", color: "#b45309",
                border: "1px solid #fde68a",
              }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                Pending at L{ws.current_level}
              </span>
            </div>
          );
        }

        return (
          <div>
            {row.approval_status == "3" && row.can_approve && (
              <div className="flex space-x-1">
                {hasAcceptPermission && (
                  <button
                    onClick={(e) => is_cn || is_sudama ? handleTalbrosApprove(e, row, true) : handleApprove(e, row)}
                    className="flex justify-center items-center rounded bg-success px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#14a44d] transition duration-150 ease-in-out hover:bg-success-600"
                  >
                    <TiTick className="mr-1" />
                    Approve
                  </button>
                )}
                {hasRejectPermission && (
                  <>
                    {tenant_id == 26 ? (
                      <button
                        onClick={(e) => handleRejectCash(e, row)}
                        className="flex justify-center items-center rounded bg-orange-500 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-lg"
                      >
                        <TiTimes className="mr-1" />
                        Reject Cash
                      </button>
                    ) : (
                      <button
                        onClick={(e) => is_cn ? handleTalbrosApprove(e, row, false) : handleReject(e, row)}
                        className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-lg"
                      >
                        <TiTimes className="mr-1" />
                        Reject
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
            {row.approval_status == "2" && <div className="bg-red-600 text-white px-2 py-1 rounded-full font-bold">Rejected</div>}
            {row.approval_status == "1" && <div className="bg-green-600 text-white px-2 py-1 rounded-full font-bold">Approved</div>}
          </div>
        );
      },
      width: "250px",
    }
  ];
  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  const generateCSV = (data) => {
    if (data.body.data.length === 0) {
      return "";
    }
  
    const header = [
      "Id",
      "Name",
      "Mobile",
      "User Type",
     "Last Balance",
     "Transfer ID",
     "Redemption Amount",
     "Created At",
      "District",
      "State",
    ];
    const rows = data.body.data.map((item, index) => [
      index + 1,
      item.name,
      item.mobile,
      item.user_type,
      item.balance,
      item.transfer_id,
      item.cash,
      item.created_at,
      item.district,
      item.state,
    ]);
  
    const csvContent = [header, ...rows]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");
  
    return `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
  };
  
  const downloadCSV = (dataUri, fileName) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = dataUri;
    downloadLink.download = fileName;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
  
    downloadLink.click();
  
    document.body.removeChild(downloadLink);
  };

  const [fetchAllScheme, { isLoading: schemeLoading, data: schemeData }] =
        useFetchAllSchemeMutation();

    useEffect(() => {
        if (onlyScheme && !schemeData?.body) {
            fetchAllScheme({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                    .tenant_id,
        body: {
          all: true
        }
            });
        }
    }, [onlyScheme]);

    const parseCSV = (string) => {
        const csvHeader = string
            .slice(0, string.indexOf("\n"))
            .replace(/\s/g, "")
            .split(",");

        const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);

        const array = csvRows
            .map((row) => {
                const values = [];
                let insideQuotes = false;
                let currentField = "";

                for (let char of row) {
                    if (char === "," && !insideQuotes) {
                        values.push(currentField.trim());
                        currentField = "";
                    } else if (char === '"') {
                        insideQuotes = !insideQuotes;
                    } else {
                        currentField += char;
                    }
                }

                values.push(currentField.trim());
                return values;
            })
            .filter((values) => values.length === csvHeader.length)
            .map((values) => {
                const obj = csvHeader.reduce((object, header, index) => {
                    object[header] = values[index].trim();
                    return object;
                }, {});
                return obj;
            });

        return array;
    };

    const handleOnSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (!bulkRedemptionsFile) {
            toast.error("Please select a file");
            return;
        }

        const fileReader = new FileReader();
        if (bulkRedemptionsFile) {
            fileReader.onload = function (event) {
                const text = event.target.result;
                let list = parseCSV(text);
                console.log("parsed csv list", list);

                const payload = {
                    list: list,
                };

                approveTalbrosBulkRedemptions({
                    token: sessionStorage.getItem("access_token"),
                    tenant_id: tenant_id,
                    body: payload,
                });

                setCsvModal(false);
            };

            fileReader.readAsText(bulkRedemptionsFile);
        }
    };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Transaction Requests List
            <LinksComponent />
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
          <div className="flex justify-between items-start">
          <div className="flex flex-row space-x-4 mb-2">
                  <CustomExport fetchData={handleCashTransferListCSV} data={csvData} defaultColumnExport={[
                  ]} 
                    filename="cash_transfer_request_list"
                    />

                    {is_cn && (
                      <>
                        <button
                          className="btn btn-outline-primary clear-both float-right"
                          onClick={() => {
                            setCsvModal(true);
                          }}
                        >
                          Bulk Update Redemptions
                        </button>
                      </>
                    )}
                </div>


            </div>
                <div className="flex w-full space-x-2">
          {onlyScheme && (
          <div className="relative w-full searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Scheme
                      </label>
            <select 
              value={request.scheme_id}
              onChange={(e) => setRequest((prev) => ({
              ...prev,
              scheme_id: e.target.value
            }))}>
              <option value="">Select Scheme</option>
              {schemeData?.body?.data?.map((item, index) => 
                <option key={index} value={item?.id}>
                  {item?.name}
                </option>
              )}
            </select>
                    </div>
          )}

                    {is_cn && (
                      <div className="relative w-full searchin">
                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Request Type
                        </label>
                        <select
                          className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          value={request.request_type}
                          onChange={(e) => {
                            const val = e.target.value;
                            setRequest((prev) => ({
                              ...prev,
                              request_type: val,
                            }));
                          }}
                        >
                          <option value="">Cash Transaction Request</option>
                          <option value="cn">Credit Note</option>
                        </select>
                      </div>
                    )}


                    <div className="relative w-full searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile No
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="Mobile..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>

                    <div className="relative w-full searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        From Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="Start Date"
                        value={request.startDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              startDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                    <div className="relative w-full searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="default-search"
                        className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="End Date"
                        value={request.endDate}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return {
                              ...prevState,
                              endDate: newValue,
                            };
                          });
                        }}
                      />
                    </div>
                  <div className="">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      &nbsp;
                    </label>

                    <div className="flex flex-row  gap-2 ">
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                          onClick={() => {
                            handleCashTransferList();
                          
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          <div className="p-3">
          {fetchAllTheCashTransferRequestsisLoading &&  <CircleLoaderComponent/>}
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
              keyField={(row) => row.SNo}
                columns={columns}
                data={tableDataItems}
                totalRows={
                  fetchAllTheCashTransferRequestsData &&
                  fetchAllTheCashTransferRequestsData?.body?.count
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
        {showModal && modalData && (
          <ModalComponent
            size={"xl"}
            data={""}
            show={showModal}
            setShow={setShowModal}
          >
            <div className="w-full">
              <div className="m-2 ">
                <div className="w-full ">

                <div className="px-2.5 py-2 mt-2">
                 
                  <div className="grid grid-cols-2 mb-2 gap-2">
                    <div className="pl-2">
                  <h2 className="text-xl font-bold mb-2 text-red-600 border-bottom border-gray-400 pb-2">User Details</h2>

                      <p className="text-gray-600 mb-1">
                        User ID:{" "}
                        <span className="font-semibold">
                          {modalData.user_id}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Name:{" "}
                        <span className="font-semibold">{modalData.name}</span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Email:{" "}
                        <span className="font-semibold">{modalData.email}</span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Mobile:{" "}
                        <span className="font-semibold">
                          {modalData.mobile}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Gender:{" "}
                        <span className="font-semibold">
                          {modalData.gender}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Date of Birth:{" "}
                        <span className="font-semibold">
                          {modalData.dob ? new Date(modalData.dob).toDateString() : "N/A"}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Address:{" "}
                        <span className="font-semibold">{`${modalData.address1}, ${modalData.city}, ${modalData.state} ${modalData.pincode}`}</span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        PAN:{" "}
                        <span className="font-semibold">{modalData.pan}</span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Aadhar:{" "}
                        <span className="font-semibold">
                          {modalData.aadhar}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        GSTIN:{" "}
                        <span className="font-semibold">
                          {modalData.gstin || "N/A"}
                        </span>
                      </p>
                      {is_lotus && (
                        <div className="mt-4">
                          <h2 className="text-xl font-bold mb-2 text-red-600 border-bottom border-gray-400 pb-2">Salon Details</h2>
                          <p className="text-gray-600 mb-1">
                            Salon ID:{" "}
                            <span className="font-semibold">{modalData.salon_id || "N/A"}</span>
                          </p>
                          <p className="text-gray-600 mb-1">
                            Salon Name:{" "}
                            <span className="font-semibold">{modalData.salon_name || "N/A"}</span>
                          </p>
                          <p className="text-gray-600 mb-1">
                            Salon Address:{" "}
                            <span className="font-semibold">{modalData.salon_address || "N/A"}</span>
                          </p>
                        </div>
                      )}
                    </div>
                    <div>
                    <h2 className="text-xl font-bold mb-2 text-red-600 border-bottom border-gray-400 pb-2">Bank Details</h2>
                    <div className="pl-2">
                      <p className="text-gray-600 mb-1">
                        Beneficiary ID:{" "}
                        <span className="font-semibold">
                          {modalData.bene_id}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Beneficiary Name:{" "}
                        <span className="font-semibold">
                          {modalData.bene_name}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Beneficiary Mobile:{" "}
                        <span className="font-semibold">
                          {modalData.bene_mobile}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Beneficiary Branch:{" "}
                        <span className="font-semibold">
                          {modalData.bene_branch}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Transfer Mode:{" "}
                        <span className="font-semibold">
                          {modalData.transfer_mode}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-1">
                        Beneficiary Details:{" "}
                        <span className="font-semibold">
                          {modalData.transfer_mode == "upi" &&
                            modalData.bene_details.upi_id}
                          {modalData.transfer_mode == "banktransfer" &&
                            ("Bank Account :",
                            modalData.bene_details.bank_account)}
                          {modalData.transfer_mode == "banktransfer" &&
                            ("IFSC :", modalData.bene_details.ifsc)}
                        </span>
                      </p>
                    </div>
                    </div>
                  </div>
                </div>

               


                <div className="px-2.5 border-top border-gray-300 pt-2">
                  <h2 className="text-xl font-bold mb-2 text-red-600 border-bottom border-gray-400 pb-2">Wallet Details</h2>
                  <div className="mb-3 mt-3">
                  <div className="grid grid-cols-4 gap-4">

                      <p className="text-gray-600 mb-2 p-2 bg-gray-100 border-gray-300 text-center rounded-sm">
                        Point Earned {" "}
                        <span className="font-semibold">
                          {modalData?.point_earned || modalData?.received_points}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-2 p-2 bg-gray-100 border-gray-300 text-center rounded-sm">
                      Point Balance{" "}
                        <span className="font-semibold">
                          {modalData?.point_balance}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-2 p-2 bg-gray-100 border-gray-300 text-center rounded-sm">
                      Point Redeemed{" "}
                        <span className="font-semibold">
                          {modalData?.point_redeemed}
                        </span>
                      </p>
                      <p className="text-gray-600 mb-2 p-2 bg-gray-100 border-gray-300 text-center rounded-sm">
                      Point Reserved{" "}
                        <span className="font-semibold">
                          {modalData?.point_reserved}
                        </span>
                      </p>
                    </div>
                    
                  </div>
                </div>
                </div>

              </div>
            </div>
          </ModalComponent>
        )}
        {csvModal && (
                        <ModalComponent show={csvModal} setShow={setCsvModal} size="md">
                          <div className="w-full p-4">
                            {currentTemplateData && currentTemplateData?.length > 0 && (
                              <div className="flex justify-center mt-3 ">
                                <button
                                  type="submit"
                                  className="mb-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                  onClick={() => downloadSampleCSV(currentTemplateData)}
                                >
                                  Sample Csv Download
                                </button>
                              </div>
                            )}
                            <div className="w-full m-auto  justify-center ">
                              <div className="flex items-center justify-center w-full">
                                <label
                                  htmlFor="dropzone-file"
                                  className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                                >
                                  <div className="flex flex-col items-center justify-center ">
                                    <svg
                                      aria-hidden="true"
                                      className="w-20 h-20 mb-3 text-gray-400 mt-2"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                      ></path>
                                    </svg>
                                    <p className="mb-2 text-sm text-gray-500 text-center">
                                      <span className="font-semibold">Choose CSV file</span>
                                      <div>Click to upload or drag and drop</div>
                                    </p>
                                  </div>
                                  <input
                                    id="dropzone-file"
                                    type="file"
                                    className="hidden"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    onChange={(e) => setBulkRedemptionsFile(e.target.files[0])}
                                  />
                                </label>
                              </div>
                            </div>
                            {currentTemplateData && currentTemplateData?.length > 0 ? (
                              <div className="flex justify-center mt-3">
                                <button
                                  type="submit"
                                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                  onClick={(e) => handleOnSubmit()}
                                >
                                  Update
                                </button>
                              </div>
                            ) : (
                              <div className="text-red-500 rounded-lg text-sm px-5 py-2.5 text-center ">
                                No Template Found !
                              </div>
                            )}
                          </div>
                        </ModalComponent>
                      )}

      {/* ── Approval History Modal ─────────────────────────────────────── */}
      {historyModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: "rgba(0,0,0,0.45)" }}
          onClick={() => setHistoryModal(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b bg-gradient-to-r from-indigo-600 to-purple-600">
              <div>
                <h2 className="text-lg font-bold text-white">Approval History</h2>
                {historyRow && (
                  <p className="text-indigo-200 text-xs mt-0.5">
                    Transfer ID: {historyRow.transfer_id || historyRow.id} &nbsp;·&nbsp; {historyRow.name}
                  </p>
                )}
              </div>
              <button
                onClick={() => setHistoryModal(false)}
                className="text-white/80 hover:text-white text-2xl leading-none"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-5 max-h-[70vh] overflow-y-auto">
              {approvalLogsLoading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-10 w-10 border-4 border-indigo-500 border-t-transparent" />
                </div>
              ) : historyLogs.length === 0 ? (
                <div className="text-center py-12 text-gray-400">
                  <svg className="mx-auto mb-3 w-12 h-12 opacity-40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="text-sm">No approval history found for this request</p>
                </div>
              ) : (
                <ol className="relative border-l-2 border-indigo-100 ml-3 space-y-6">
                  {historyLogs.map((log, idx) => {
                    const isApproved = log.status === "1" || log.status === "approved";
                    const isRejected = log.status === "0" || log.status === "rejected";
                    const dotColor   = isApproved ? "bg-green-500" : isRejected ? "bg-red-500" : "bg-yellow-400";
                    const badgeClass = isApproved
                      ? "bg-green-100 text-green-700 border border-green-200"
                      : isRejected
                      ? "bg-red-100 text-red-700 border border-red-200"
                      : "bg-yellow-100 text-yellow-700 border border-yellow-200";
                    const statusLabel = isApproved ? "Approved" : isRejected ? "Rejected" : log.status;

                    return (
                      <li key={idx} className="ml-6">
                        {/* Timeline dot */}
                        <span className={`absolute -left-[9px] flex items-center justify-center w-4 h-4 rounded-full ring-4 ring-white ${dotColor}`} />

                        <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 shadow-sm">
                          {/* Level + status */}
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-xs font-semibold text-indigo-600 uppercase tracking-wide">
                              Level {log.level}
                              {log.total_levels ? ` / ${log.total_levels}` : ""}
                            </span>
                            <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${badgeClass}`}>
                              {statusLabel}
                            </span>
                          </div>

                          {/* Actor */}
                          <div className="flex items-center gap-2 mb-1">
                            <div className="w-7 h-7 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-xs shrink-0">
                              {(log.user_name || "?")[0].toUpperCase()}
                            </div>
                            <div>
                              <p className="text-sm font-medium text-gray-800 leading-tight">{log.user_name || "—"}</p>
                              {log.user_role_name && (
                                <p className="text-xs text-gray-400">{log.user_role_name}</p>
                              )}
                            </div>
                          </div>

                          {/* Remarks */}
                          {log.remarks && (
                            <div className="mt-2 text-xs text-gray-600 bg-white border border-gray-200 rounded-lg px-3 py-2 italic">
                              "{log.remarks}"
                            </div>
                          )}

                          {/* Date */}
                          <p className="mt-2 text-xs text-gray-400 text-right">
                            {new Date(log.created_at).toLocaleString("en-IN", {
                              day: "2-digit", month: "short", year: "numeric",
                              hour: "2-digit", minute: "2-digit",
                            })}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ol>
              )}
            </div>

            {/* Footer */}
            <div className="px-6 py-3 border-t bg-gray-50 flex justify-end">
              <button
                onClick={() => setHistoryModal(false)}
                className="px-5 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ──────────────────────────────────────────────────────────────────── */}

      {/* ── Sudama Approve Modal ───────────────────────────────────────────── */}
      {sudamaModal && (() => {
        const ws = rowWorkflowStatus[sudamaRow?.id];
        const isFinalLevel = !ws || ws.no_workflow || (ws.current_level === ws.total_levels);
        const showUtrField = sudamaIsApproved && isFinalLevel;

        return (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center"
            style={{ background: "rgba(0,0,0,0.45)" }}
            onClick={() => setSudamaModal(false)}
          >
            <div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className={`px-6 py-4 border-b bg-gradient-to-r ${sudamaIsApproved ? "from-green-600 to-emerald-600" : "from-red-600 to-rose-600"}`}>
                <h2 className="text-lg font-bold text-white">
                  {sudamaIsApproved ? "Approve Request" : "Reject Request"}
                </h2>
                {sudamaRow && (
                  <p className="text-white/75 text-xs mt-0.5">
                    {sudamaRow.name} &nbsp;·&nbsp; ₹{sudamaRow.cash}
                  </p>
                )}
              </div>

              {/* Body */}
              <div className="px-6 py-5 flex flex-col gap-4">
                {/* UTR — only shown when approving at last level and is mandatory */}
                {showUtrField && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      UTR <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
                      placeholder="Enter UTR number"
                      value={sudamaUtr}
                      onChange={(e) => setSudamaUtr(e.target.value)}
                    />
                  </div>
                )}

                {/* Remark — required */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Remark <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    rows={3}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 resize-none"
                    placeholder="Enter remark..."
                    value={sudamaRemark}
                    onChange={(e) => setSudamaRemark(e.target.value)}
                  />
                </div>
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-2">
                <button
                  onClick={() => setSudamaModal(false)}
                  className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSudamaConfirm}
                  className={`px-5 py-2 text-sm font-medium text-white rounded-lg transition ${
                    sudamaIsApproved
                      ? "bg-green-600 hover:bg-green-700"
                      : "bg-red-600 hover:bg-red-700"
                  }`}
                >
                  {sudamaIsApproved ? "Confirm Approve" : "Confirm Reject"}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      </div>

    </>
  );
};

export default CashTransferRequests;


